export const BASE_URL = "https://kurye.handsfreeapi.com";
export const KEY = "CeQJ3t6OT8Ka5RTiDPU1tBepbUQumY";
export const SECRET = "4VtrWHHHrWYmnYUlOHncj7DSlapfhA";
